import { StatusViewModel, WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class StatusStoreService {
  _status$ = new BehaviorSubject<StatusViewModel[]>(null);

  constructor(private statusSertice: WalkAndPunchApiClient) {}

  loadStatus(onlyVisible: boolean) {
    return this.statusSertice.v1StatusGetAllStatusGET(onlyVisible);
  }

  get status() {
    return this._status$.value;
  }

  set status(data: StatusViewModel[]) {
    this._status$.next(data);
  }

  get status$() {
    return this._status$;
  }
}
